import { gql } from "@apollo/client";

export const GET_PET_INFO = gql`
  query petInfo($id: String!) {
    petInfoV2(
      petId: $id
    ) {
      pet {
        id,
        name,
        image,
        species,
        speciesName,
        breed,
        breedName,
        birthdate,
        age,
        gender,
        medicalRecord {
          city,
          clinicName,
        },
        microchip {
          microchipNumber,
          details {
            title,
            description,
          },
        },
        isDesexed,
        color,
        idColor,
      },
    }
  }
`;
